import { SyncOutlined } from "@ant-design/icons";
import styles from "./RefreshBtn.module.scss";
import cn from "classnames";
import { IRefreshBtnProps } from "./RefreshBtn.props";

export default function RefreshBtn({
  className,
  loading,
  onClick,
}: IRefreshBtnProps) {
  const onRefresh = async () => {
    await onClick();
  };

  return (
    <div className={cn(styles.wrapper, className)} onClick={onRefresh}>
      <SyncOutlined className={styles.icon} spin={loading} rev={undefined} />
    </div>
  );
}
